import { useEffect } from "react";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  siteName?: string;
}

const SEO = ({
   title = "LearnHub Institute - Online Learning Platform",
   description = "Join 50,000+ learners mastering in-demand skills with expert-led courses, personalized mentorship, and career-focused programs.",
   keywords = "online learning, tech courses, web development, data science, mentorship, certification, career training, LearnHub Institute",
   image = "https://www.learnhub.institute/logo.png",
   url = "https://www.learnhub.institute/",
   type = "website",
   siteName = "LearnHub Institute",
 }: SEOProps) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update meta tags
    const updateMeta = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const updateProperty = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("property", property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const updateLink = (rel: string, href: string) => {
      let link = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement;
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = href;
    };

    // Basic SEO
    updateMeta("description", description);
    updateMeta("keywords", keywords);

    // Open Graph
    updateProperty("og:title", title);
    updateProperty("og:description", description);
    updateProperty("og:image", image);
    updateProperty("og:url", url);
    updateProperty("og:type", type);
    updateProperty("og:site_name", siteName);

    // Twitter
    updateMeta("twitter:title", title);
    updateMeta("twitter:description", description);
    updateMeta("twitter:image", image);

    // Canonical
    updateLink("canonical", url);

    return () => {
      // Cleanup is optional - meta tags can persist for SPA navigation
    };
  }, [title, description, keywords, image, url, type, siteName]);

  return null;
};

export default SEO;